import * as C from 'actions/constants';

export const blankState = {
  data: JSON.parse(localStorage.getItem('auth')) || {},
  loading: false,
};

const SessionReducer = (state = blankState, action) => {
  switch (action.type) {
    case C.SIGN_IN:
    case C.REFRESH_TOKEN: {
      return { ...state, loading: true };
    }
    case C.REFRESH_TOKEN_SUCCESS:
    case C.SIGN_IN_SUCCESS: {
      const { data } = action;
      return { ...state, loading: false, data };
    }
    case C.SIGN_OUT_ERROR:
    case C.REFRESH_TOKEN_ERROR:
    case C.SIGN_IN_ERROR: {
      return { ...state, loading: false };
    }
    default:
      return state;
  }
};

export default SessionReducer;
